import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Kanit\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\"],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"kanit\"}");
;
import(/* webpackMode: "eager", webpackExports: ["FixedPlugin"] */ "/app/src/components/fixed-plugin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/app/src/components/layout.tsx");
